var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "equalizer_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/av/equalizer_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5V7L10 7V5H2ZM2 2V4H6V2H2ZM2 8H7.5V10H2L2 8Z",
    fill: "#878889"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalList);
export default __webpack_public_path__ + "static/media/total_list.4c458ebb62d52af0de75d9dacebdea4a.svg";
export { ForwardRef as ReactComponent };